if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection?.querySelector('.product-info');
      this.purchaseActions = this.productSection?.querySelector('[data-purchase-actions]');
      this.handleNotifyClick = this.handleNotifyClick.bind(this);

      if ('IntersectionObserver' in window) this.bindEvents();
      this.productSection?.addEventListener('click', this.handleNotifyClick);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.productSection?.removeEventListener('click', this.handleNotifyClick);
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    bindEvents() {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.purchaseActions && !theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.boundingClientRect.bottom > 0);
          } else if (entry.target === this.productInfo && theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
          }
        });
      });

      if (this.purchaseActions) this.observer.observe(this.purchaseActions);
      if (this.productInfo) this.observer.observe(this.productInfo);

      window.addEventListener('scroll', StickyAtcPanel.handleScroll, { passive: true });
      StickyAtcPanel.handleScroll();
    }

    handleNotifyClick(event) {
      const colorOptionsTrigger = event.target.closest('[data-color-options-trigger]');
      if (colorOptionsTrigger) {
        const pickerAnchor = this.productSection?.querySelector('#variants');
        const picker = pickerAnchor?.nextElementSibling;
        if (!picker?.classList.contains('product-options')) return;

        event.preventDefault();

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const optionPosition = Number.parseInt(colorOptionsTrigger.dataset.colorOptionPosition, 10);
        const selectedColor = Number.isInteger(optionPosition)
          ? picker.querySelector(`input[type="radio"][name$="-${optionPosition}-option"]:checked`)
          : null;
        const focusTarget = selectedColor || picker.querySelector('input[type="radio"]:checked, select, button');

        pickerAnchor.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
        window.setTimeout(() => focusTarget?.focus({ preventScroll: true }), reduceMotion ? 0 : 350);
        return;
      }

      const trigger = event.target.closest('[data-notify-trigger]');
      if (!trigger) return;

      const panel = this.productSection?.querySelector('[data-notify-panel]');
      if (!panel) return;

      event.preventDefault();
      panel.hidden = false;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      panel.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });

      window.setTimeout(() => {
        panel.querySelector('input[type="email"]')?.focus({ preventScroll: true });
      }, reduceMotion ? 0 : 350);
    }

    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
